import {Tr} from "@/i18n/i18n";
import {injectable} from "inversify";
import {PlayerMarker} from "@/store/player/types";
import {UpdateArtifactPanel} from "@/scenes.ui/update-artifact-panel";
import {ArtifactSlot} from "@/scenes.ui/artifact-slot";
import EducationPanel from "@/scenes.ui/education-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import {ImageButton} from "@/scenes.ui/image-button";
import Image = Phaser.GameObjects.Image;
import Container = Phaser.GameObjects.Container;
import {Markers} from "@/constants/marker";
import PlayerStore from "@/store/player";
import SpriteUtils from "@/utils/sprite-utils";

@injectable()
export class ArtifactLessonService {

    private scene!: Scene;
    private educationPanel: EducationPanel | undefined;
    private flyingArrow: Image | undefined;

    private educationActive: boolean = true;

    public onPageOpen(scene: Scene, slot: ArtifactSlot): void {
        this.educationActive = this.isLessonInProgress();
        if (this.educationActive) {
            this.scene = scene;

            if (this.haveMarker(Markers.ART_TAKEN_MARKER) && !this.haveMarker(Markers.HERO_VISITED_AFTER_PROMPT_MARKER)) {
                PlayerStore.setMarker(Markers.HERO_VISITED_AFTER_PROMPT_MARKER);
            }

            if (ArtifactLessonService.hasArtifact()) {
                if (!this.educationPanel || !this.educationPanel.active || !this.educationPanel.scene || !this.educationPanel.scene.scene.isActive()) {
                    this.educationPanel = new EducationPanel(scene, 0, undefined);
                    this.educationPanel.setDepth(10000);
                    scene.add.existing(this.educationPanel);
                }

                if (!this.haveMarker(Markers.ART_UPDATE_STARTED_MARKER)) {

                    this.educationPanel!.init(PlayerStore.getPlayer()!.companionImage, Tr('vidish.eto.schit.kotoriy.mi.nashli'), () => {
                    });

                    this.showArrow(slot, 35, -25, false);
                }
            }

        }
    }

    public onUpdatePanelOpened(uap: UpdateArtifactPanel): void {
        if (this.educationActive) {

            if (!this.haveMarker(Markers.ART_UPDATE_STARTED_MARKER)) {

                this.educationPanel!.init(PlayerStore.getPlayer()!.companionImage, Tr('a.teper.nazhmi.uluchshit.'), () => {});

                this.showArrow(uap, 125, 210, false);
            }

        }
    }

    public onImproveClicked() {
        if (this.educationActive) {

            this.educationPanel!.init(PlayerStore.getPlayer()!.companionImage, Tr('otlichno.mozhem.podozhdat.sekund.ili.uskorit.i.ne.zhdat.'), () => {});
            this.removeArrow();

            PlayerStore.SET_MARKER(Markers.ART_UPDATE_STARTED_MARKER);
            PlayerStore.setMarker(Markers.ART_UPDATE_STARTED_MARKER);
        }
    }

    public onChange(roadButton: ImageButton) {
        if (this.educationActive) {
            if (this.haveMarker(Markers.ART_EDU_COMPLETED_MARKER) && !this.haveMarker(Markers.ROAD_EDU_COMPLETED_MARKER)) {
                let player = PlayerStore.getPlayer()!;
                for (let c of player.creatures) {
                    for (let a of c.artifacts) {
                        if (a.level > 1) {
                            this.educationPanel!.init(PlayerStore.getPlayer()!.companionImage, Tr('otlichno.schit.teper.daet.k.zaschite'), () => {
                            });

                            roadButton.setVisible(true);
                            this.showArrow(roadButton, -135, -15, true);

                            return;
                        }
                    }
                }
            }
        }
    }

    public isLessonInProgress(): boolean {
        return this.haveMarker(Markers.ART_TAKEN_MARKER) && !this.haveMarker(Markers.ART_EDU_COMPLETED_MARKER);
    }

    private static hasArtifact(): boolean {
        let player = PlayerStore.getPlayer()!;
        for (let c of player.creatures) {
            if (c.artifacts.length > 0) {
                return true;
            }
        }
        return false;
    }

    private haveMarker(marker: String): Boolean {
        return PlayerStore.getPlayer()!.playerMarkers.some((m: PlayerMarker) => m.playerMarker == marker);
    }

    private showArrow(container: Container, shiftX: number, shiftY: number, flipX: boolean) {
        this.removeArrow();
        this.flyingArrow = SpriteUtils.addSprite(this.scene!, shiftX, shiftY, Keys.ATLAS_UI, Keys.ARROW_CROSS).setOrigin(0, 1);
        container.add(this.flyingArrow);
        this.flyingArrow.setDepth(30000);
        this.flyingArrow.setAlpha(0);
        this.flyingArrow.flipX = flipX;

        this.scene!.tweens.chain({
            targets: this.flyingArrow,
            tweens: [{},
                {
                    delay: 1000,
                    duration: 1000,
                    alpha: 1
                }]
        });
        this.scene!.tweens.add({
            targets: this.flyingArrow,
            delay: 0,
            duration: 2000,
            x: this.flyingArrow.x + (flipX ? -20 : 20),
            y: this.flyingArrow.y - 25,
            yoyo: true,
            loop: -1,
        });
    }

    private removeArrow() {
        if (this.flyingArrow) {
            this.flyingArrow.setVisible(false);
            this.flyingArrow.destroy();
            this.flyingArrow = undefined;
        }
    }
}
